export default __webpack_public_path__ + "static/media/body-section-quadriceps.a80a7d34.png";